import { render, staticRenderFns } from "./SelectGroups.vue?vue&type=template&id=2cfccdfe&"
import script from "./SelectGroups.vue?vue&type=script&lang=ts&"
export * from "./SelectGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports